import { configureStore, Action } from '@reduxjs/toolkit';
import thunk, { ThunkAction } from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import rootReducer, { RootState } from './reducer';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['order'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = typeof window !== 'undefined' ? persistStore(store) : null;
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
